import { Component, OnInit, Input } from '@angular/core';
import { QuoteRequest } from 'src/app/services_autogenerated/generated_services';
import { Router, NavigationExtras } from '@angular/router';

@Component({
    selector: 'app-customer-firmtime-quote-row',
    templateUrl: './customer-firmtime-quote-row.component.html',
    styleUrls: ['./customer-firmtime-quote-row.component.css'],
    standalone: false
})
export class CustomerFirmtimeQuoteRowComponent implements OnInit {
  @Input() quote: QuoteRequest;
  firmtimeQuotePrice = 100;
  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  navigate() {
    const extras: NavigationExtras = {
      queryParams: { 'asAnonymous': 'true' }
    };
    
    this.router.navigate(['/ftSchedulePage/' + this.quote.id], extras);
  }

}
